var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{staticClass:"app-toast",class:{
    info: _vm.type === 'info',
    success: _vm.type === 'success',
    warning: _vm.type === 'warning',
    error: _vm.type === 'error'
  }},[_c('v-row',{attrs:{"align":"center","no-gutters":""}},[_c('div',{staticStyle:{"padding":"8px 16px"}},[_c('pre',[_vm._v(_vm._s(_vm.text))])]),_c('v-spacer'),_c('v-col',{staticClass:"shrink"},[(_vm.useButton)?_c('v-btn',{on:{"click":_vm.close}},[_vm._v(" Okay ")]):_vm._e()],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }